import axios from '../config/axios.js';

class CommonService {
  getCountries = () => {
    return axios
      .get('/get-countries')
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getCustomerBalance = () => {
    return axios
      .get('/get-customer-balance')
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getSecurityQuestions = () => {
    return axios
      .get('/get-securtiy-questions')
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };
}
export default new CommonService();
